import { assignVars, globalStyle, styleVariants } from "@vanilla-extract/css";
import { breakpoints } from "./breakpoints";
import "./fonts.css";
import { headingFontSizeVars, vars } from "./theme.css";
import { desktopHeadingFontSizes, mobileHeadingFontSizes } from "./typography";

globalStyle("*, *::before, *::after", {
  boxSizing: "border-box",
});

globalStyle(":root", {
  backgroundColor: vars.colors.bgColor,
  scrollBehavior: "smooth",
  lineHeight: 1.4,
  vars: assignVars(headingFontSizeVars, mobileHeadingFontSizes),
  "@media": {
    [`screen and (min-width: ${breakpoints[2]})`]: {
      vars: assignVars(headingFontSizeVars, desktopHeadingFontSizes),
    },
  },
});

globalStyle(":root.sheet-open", {
  overflow: "hidden",
});

globalStyle("html", {
  // Reluctantly using 62.5% to match Pulse's default font size.
  fontSize: "62.5%",
});

// We reset our own styles here to ensure we don't interfere with the Pulse header and footer.
globalStyle(".ism", {
  backgroundColor: vars.colors.bgColor,
  scrollbarColor: `${vars.colors.onSurfaceVariant} ${vars.colors.bgColor}`,
  letterSpacing: "-0.02em",
  color: vars.colors.primary,
  fontFamily: vars.fonts.regular,
  fontSize: vars.fontSizes.body.m,
});

// Pulse reset - override unwanted pulse ism.css styles
globalStyle("label", {
  color: "inherit",
});

// iOS Safari button reset
// Wrapped in :where pseudo-class to avoid specificity issues
// https://premierleague.atlassian.net/browse/FPL-1833?focusedCommentId=38342
globalStyle(
  `:where(input:is([type="button"], [type="submit"], [type="reset"]),
input[type="file"]::file-selector-button,
button)`,
  {
    alignItems: "normal",
  },
);

globalStyle("h1, h2, h3, h4, h5, h6", {
  margin: 0,
  lineHeight: "1.2",
  fontFamily: vars.fonts.bold,
  fontWeight: 400,
});

globalStyle("h1", {
  fontSize: vars.fontSizes.heading["2xl"],
});

globalStyle("h2", {
  fontSize: vars.fontSizes.heading["xl"],
});

globalStyle("h3", {
  fontSize: vars.fontSizes.heading["l"],
});

globalStyle("h4", {
  fontSize: vars.fontSizes.heading["m"],
});

globalStyle("h5", {
  fontSize: vars.fontSizes.heading["s"],
});

globalStyle("h6", {
  fontSize: vars.fontSizes.heading["xs"],
});

globalStyle("strong", {
  fontFamily: vars.fonts.bold,
  fontWeight: 400,
});

globalStyle("p", {
  margin: 0,
  color: vars.colors.onSurface,
});

globalStyle("ol, ul, dd", {
  margin: 0,
  padding: 0,
  listStyle: "none",
});

globalStyle("ol, ol > li", { listStyle: "decimal" });

globalStyle("strong", {
  fontFamily: vars.fonts.bold,
});

globalStyle("table", {
  width: "100%",
  borderCollapse: "collapse",
});

globalStyle("th", {
  color: vars.colors.onSurfaceVariant,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
  fontWeight: 400,
});

globalStyle("td", {
  textWrap: "nowrap",
});

globalStyle("::-webkit-scrollbar-track", {
  borderRadius: vars.radii.s,
  backgroundColor: "transparent",
});

globalStyle("::-webkit-scrollbar-thumb", {
  borderRadius: vars.radii.s,
  backgroundColor: vars.colors.onSurfaceVariant,
});

globalStyle("::-webkit-scrollbar-thumb:hover", {
  borderRadius: vars.radii.s,
  backgroundColor: vars.colors.tonal,
});

globalStyle("::-webkit-scrollbar-track:hover", {
  borderRadius: vars.radii.s,
  backgroundColor: vars.colors.tonal,
});

// Fix overflow issue with game updating article from Pulse CMS (UpdatingContent.tsx)
// https://premierleague.atlassian.net/browse/FPL-1487
globalStyle("#mainContent.ism", {
  overflow: "initial",
});

const baseGlassStyle = {
  backgroundColor: vars.colors.glass,
  color: vars.colors.onGlass,
};

export const glass = styleVariants({
  default: [baseGlassStyle, { backdropFilter: vars.blur[10] }],
  card: [baseGlassStyle, { backdropFilter: vars.blur[2] }],
});
